/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { BarWave } from 'react-cssfx-loading';
import PropTypes from 'prop-types';
import LinkButton from '../../../components/Buttons/LinkButton';
import bannerImage from '../../assets/images/banner.jpg';

function Banner(props) {
  const { loading } = props;
  const content = (
    <>
      <p className="xl:text-xl text-md">UCAA ANS SMS</p>
      <h1 className="xl:w-2/3 w-5/6 font-bold lg:text-6xl md:text-4xl text-2xl xl:py-8 md:py-5 py-3">
        ANS Safety Management Systems
      </h1>
      <p className="lg:text-lg text-md xl:p-4 p-2 md:w-1/2 w-full">
        {'A '}
        <span className="text-blue-300">{'Safety Management System '}</span>
        for the Directorate of Air Navigation Services
      </p>
      <p className="xl:p-5 p-3 xl:text-lg md:text-md text-sm md:w-1/2 w-full xl:mb-8 mb-4">
        REPORT AIRCRAFT & WORKPLACE ISSUES, INCIDENTS AND HAZARDS.
        SMS EXPERTS WILL ANALYZE AND ADDRESS THEM
      </p>
      <LinkButton path="/public/report" linktext="Report Occurrence" />
    </>
  );

  return (
    <div
      className="bg-cover text-white w-full xl:mt-24 mt-16"
      style={{ backgroundImage: `url(${bannerImage})` }}
    >
      <div
        className={
          loading
            ? 'bg-gray-900 bg-opacity-90 lg:p-16 p-8 fixed z-50 w-full h-full flex flex-col items-center justify-center'
            : 'bg-gradient-to-r from-gray-900 to-transparent lg:p-16 p-8'
        }
      >
        {loading ? <BarWave color="#54c5fc" height="2rem" width="8rem" /> : content}
      </div>
    </div>
  );
}

Banner.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default Banner;
